// import Todo from './model/todo';

const initialState = {
  todos: [
    // new Todo(1, '123', false),
    // new Todo(2, '456', true),
    // new Todo(3, '789', false),
    // new Todo(4, '012', true),
    // new Todo(5, '345', false),
  ],
};

export default initialState;



// WEBPACK FOOTER //
// ./src/dataControl/initialState.js